import { ProfileTitle } from './ProfileTitle';
import { ProfileCarouselButton } from './ProfileCarouselButton';
import { ProfileImage } from './ProfileImage';
import type { DisplayMember, PaginationProps } from './types';

/**
 * Displays a professional's profile card with image, name, job title and navigation controls
 */

interface ProfileCardProps extends Omit<PaginationProps, 'totalItems'> {
    member: DisplayMember;
    filteredMembers: DisplayMember[];
    showNavigation?: boolean;
}

export const ProfileCard = ({
    member,
    handlePrev,
    handleNext,
    showNavigation = false,
}: ProfileCardProps) => {
    return (
        <div>
            <div className="relative h-140 w-120">
                <ProfileImage
                    profileImageSrc={member.detailsPageImageSrc}
                    name={member.name}
                />
            </div>

            <div className="mt-5">
                <div className="flex w-120 items-start">
                    <div className="min-w-0 flex-1 pr-4">
                        <ProfileTitle
                            name={member.name}
                            jobTitle={member.jobTitle}
                        />
                    </div>
                    {showNavigation && (
                        <div className="shrink-0">
                            <ProfileCarouselButton
                                handlePrev={handlePrev}
                                handleNext={handleNext}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
